import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {Tool} from "../../model/tool";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class ToolFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(tool: Tool): Observable<FieldDefinition<any>[]> {
    let questions;
    if (tool.type === 'TOOL') {
      questions = [
        new FieldDefinition<string>({
          key: "title",
          label: 'Titre du bloc',
          type: 'text',
          value: tool.title,
          required: true,
          order: 1
        }),
        new FieldDefinition<string>({
          key: "description",
          label: 'Texte du bloc',
          type: 'editor',
          value: tool.description,
          required: true,
          order: 2
        }),
        new FieldDefinition<string>({
          key: 'buttonTitle',
          label: 'Titre du bouton',
          type: 'text',
          value: tool.buttonTitle,
          required: true,
          order: 3
        }),
        new FieldDefinition<string>({
          key: 'link',
          label: 'Lien du bouton',
          type: 'text',
          value: tool.link,
          required: true,
          order: 4
        }),
        new FieldDefinition<string>({
          key: 'buttonType',
          label: 'Style du bouton',
          type: 'btn-radio',
          value: tool.buttonType,
          options: [
            {key: 'PRIMARY', value: "Primaire"},
            {key: 'SECONDARY', value: "Secondaire"},
          ],
          required: true,
          order: 5
        }),
      ];
    } else {
      questions = [
        new FieldDefinition<string>({
          key: "title",
          label: 'Titre du bloc',
          type: 'text',
          value: tool.title,
          required: true,
          order: 1
        }),
        new FieldDefinition<string>({
          key: "description",
          label: 'Texte du bloc',
          type: 'editor',
          value: tool.description,
          required: true,
          order: 2
        })
      ]
    }

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
